module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAcCAYAAAAN3M1lAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAJqADAAQAAAABAAAAHAAAAABvY4B8AAABBElEQVRYCc3WSQrCQBAF0DgPZ/IugodwWKitW+/iPKCIeDCn/8UKGmphhFhV8OnYJulHpdEUomxrgts3kHO2y6S7O1H3V0bpLs3u7NYbyhWuAthWwQXMmRdxG0Q6JmMwlwFQRlaIoGQMmDMv4paIoGQcmssAIG7hFVcCbK7gBpgzL+JmiDxOGd3gpt/gcjjp3+Ge03B9zMcl7fQyPnHFmOfnYExK3o/nQ3Lhp6tRblhX2z49oqyKm1/7TTNHaX9RXasucV2+cayR5CM0R2mvQaaoKrq089YpovYKqoM5s6ph5QOS3FPmqKM3VB2gkzcUPFFTQbX5hYcKQMjecoOSxhD3E+oBNgu5yTfh1g0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_home_right_arrow.png
// module id = YvJt
// module chunks = 1